import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import DefectsContent from "../../components/Defects/DefectsContent";
import {
  getDepartmentMasterList,
  getVesselMasterList,
} from "../../redux/actions/mastersAction";
import { useDispatch, useSelector } from "react-redux";

const Defects = () => {
  const dispatch = useDispatch();

  const CompanyID = localStorage.getItem("companyID");

  useEffect(() => {
    dispatch(
      getDepartmentMasterList({
        companyId: CompanyID,
      })
    );
    dispatch(
      getVesselMasterList({
        active: "true",
        searchByFirstName: "",
        limit: "",
        offset: "",
      })
    );
  }, []);

  return (
    <>
      <Sidebar activeTab="Defects" title="Defects">
        <Box className="globalContainer_For_Content">
          <DefectsContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default Defects;
